module.exports = __webpack_public_path__ + "static/img/0011.3cd92bd6.png";